import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
  import Modal from "@/components/ui/Modal.vue";

  interface Props {
    isOpen: boolean;
    lotTitle: string;
    currentCondition: string;
    options: string[];
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ConditionsModal',
  props: {
    isOpen: { type: Boolean },
    lotTitle: {},
    currentCondition: {},
    options: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;

  const selectedCondition = ref<string>("");

  const allOptions = computed(() => props.options);

  const selectCondition = (condition: string) => {
    if (condition !== props.currentCondition) {
      selectedCondition.value = condition;
    }
  };

  const close = () => {
    selectedCondition.value = "";
    emit("close");
  };

  const confirm = () => {
    if (
      selectedCondition.value &&
      selectedCondition.value !== props.currentCondition
    ) {
      emit("confirm", selectedCondition.value);
      close();
    }
  };

const __returned__ = { props, emit, selectedCondition, allOptions, selectCondition, close, confirm, ref, computed, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})